import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import TemperatureUp from '../../Assets/Weather/TemperatureUp.png';
import TemperatureDown from '../../Assets/Weather/TemperatureUp.png';
import CloudRain from '../../Assets/Weather/TemperatureUp.png';
import Humidity from '../../Assets/Weather/Humidity.png';

const weather_styles = StyleSheet.create({
  weather_overview_item_container: {
    width: '170px',
    marginBottom: 12,
    padding: 12,
    borderRadius: 16,
    backgroundColor: '#b9e5ffff',
    color: '#000000',
    fontSize: 12,
    alignItems: 'center'
  },
  weather_overview_item: { flexDirection: 'row', width: '100%' },
  weather_overview_item_icon: { width: 16, marginRight: 4, padding: 2 }
});
export type WeeklyWeatherOverviewProps = {
  week_no: number;
  styles: any;
  data: any;
};
const WeeklyWeatherOverview = (props: WeeklyWeatherOverviewProps) => (
  <View
    style={{
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <View
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 8
      }}
    >
      <Text style={{ fontSize: 12 }}>Week {props.week_no} Overview</Text>
      <Text style={{ fontSize: 10 }}>Week {props.data.dates}</Text>
    </View>
    <View
      style={{
        flexDirection: 'row',
        flexWrap: 'wrap',
        display: 'flex',
        justifyContent: 'space-evenly'
      }}
    >
      {/* Max Temperature Average */}
      <View style={weather_styles.weather_overview_item_container}>
        <View style={weather_styles.weather_overview_item}>
          <Image style={weather_styles.weather_overview_item_icon} src={TemperatureUp}></Image>
          <Text style={{ fontSize: 11 }}>Max Temp Average</Text>
        </View>
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8, marginTop: 6 }}>
          {props.data.maxTempC.avg.toFixed(2)}°
        </Text>
        <View style={{ alignItems: 'flex-end', width: '100%' }}>
          <Text style={{ fontSize: 10, marginBottom: 2 }}>
            Highest : {props.data.maxTempC.max}°
          </Text>
          <Text style={{ fontSize: 10, marginTop: 2 }}>Lowest : {props.data.maxTempC.min}°</Text>
        </View>
      </View>
      {/* Rainfall Average */}
      <View style={weather_styles.weather_overview_item_container}>
        <View style={weather_styles.weather_overview_item}>
          <Image style={weather_styles.weather_overview_item_icon} src={CloudRain}></Image>
          <Text style={{ fontSize: 11 }}>Rainfall Average</Text>
        </View>
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8, marginTop: 8 }}>
          {props.data.precipMM.avg.toFixed(2)}mm
        </Text>
        <View style={{ alignItems: 'flex-end', width: '100%' }}>
          <Text style={{ fontSize: 10, marginBottom: 2 }}>
            Highest : {props.data.precipMM.max}mm
          </Text>
          <Text style={{ fontSize: 10, marginTop: 2 }}>Lowest : {props.data.precipMM.min}mm</Text>
        </View>
      </View>
      {/* Min Temperature Average */}
      <View style={weather_styles.weather_overview_item_container}>
        <View style={weather_styles.weather_overview_item}>
          <Image style={weather_styles.weather_overview_item_icon} src={TemperatureDown}></Image>
          <Text style={{ fontSize: 11 }}>Min Temp Average</Text>
        </View>
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8, marginTop: 8 }}>
          {props.data.minTempC.avg.toFixed(2)}°
        </Text>
        <View style={{ alignItems: 'flex-end', width: '100%' }}>
          <Text style={{ fontSize: 10, marginBottom: 2 }}>
            Highest : {props.data.minTempC.max}°
          </Text>
          <Text style={{ fontSize: 10, marginTop: 2 }}>Lowest : {props.data.minTempC.min}°</Text>
        </View>
      </View>
      {/* Humidity Average */}
      <View style={weather_styles.weather_overview_item_container}>
        <View style={weather_styles.weather_overview_item}>
          <Image style={weather_styles.weather_overview_item_icon} src={Humidity}></Image>
          <Text style={{ fontSize: 11 }}>Humidity Average</Text>
        </View>
        <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8, marginTop: 8 }}>
          {props.data.humidity.avg.toFixed(2)}%
        </Text>
        <View style={{ alignItems: 'flex-end', width: '100%' }}>
          <Text style={{ fontSize: 10, marginBottom: 2 }}>
            Highest : {props.data.humidity.max}%
          </Text>
          <Text style={{ fontSize: 10, marginTop: 2 }}>Lowest : {props.data.humidity.min}%</Text>
        </View>
      </View>
    </View>
  </View>
);

export default WeeklyWeatherOverview;
